import React from "react";
import BaseDialog from "../baseDialog/BaseDialog";

const DeleteDialog = (props) => (
  <BaseDialog
    show={props.show}
    onHide={props.onHide}
    title={props.title}
    dialogApiError={props.dialogApiError}
    body={props.body}
    rightButtonCallback={props.onSubmit}
    rightButtonText={props.rightButtonText}
    leftButtonText={props.leftButtonText}
    rightButtonVariant="red"
    leftButtonVariant="black"
    leftButtonCallback={props.onHide}
  />
);

export default DeleteDialog;
